// extracted by mini-css-extract-plugin
export var card = "card-module--card--v-4KZ";
export var logo = "card-module--logo--GfesP";
export var term = "card-module--term--Qw1Ww";
export var title = "card-module--title--Oy-Vi";